import React from 'react';

export const Detail = ({ detail }) => (
  <div>
    <span>{detail || '-'}</span>
  </div>
);
